import React from 'react';
import { useSalon } from '../context/SalonContext';
import './OpeningHours.css';

// Fallback si pas de données
const defaultHours = [
  { day: 1, open: "09:00", close: "18:00", break_start: "12:00", break_end: "14:00", is_closed: false },
  { day: 2, open: "09:00", close: "18:00", break_start: "12:00", break_end: "14:00", is_closed: false },
  { day: 3, open: "09:00", close: "18:00", break_start: "12:00", break_end: "14:00", is_closed: false },
  { day: 4, open: "09:00", close: "18:00", break_start: "12:00", break_end: "14:00", is_closed: false },
  { day: 5, open: "09:00", close: "18:00", break_start: "12:00", break_end: "14:00", is_closed: false },
  { day: 6, open: "Close", close: "Close", is_closed: true },
  { day: 7, open: "Close", close: "Close", is_closed: true }
];

const daysMap = { 1: 'Lundi', 2: 'Mardi', 3: 'Mercredi', 4: 'Jeudi', 5: 'Vendredi', 6: 'Samedi', 7: 'Dimanche' };

function OpeningHours() {
  const { openingHours, salonInfos, blockedDates, loading } = useSalon();

  // Utiliser les données du contexte ou le fallback
  const hoursToDisplay = (openingHours && openingHours.length > 0) ? openingHours : defaultHours;

  const todayIndex = new Date().getDay(); // 0=Dimanche, 1=Lundi...
  // Convertir 0 (Dimanche) en 7 pour matcher notre format
  const currentDayId = todayIndex === 0 ? 7 : todayIndex;

  // Filtrer les dates bloquées futures (pour les afficher en alerte)
  const futureBlockedDates = blockedDates?.filter(d => new Date(d.date) >= new Date().setHours(0, 0, 0, 0))
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(0, 5) || [];

  const formatTime = (time) => {
    if (!time) return '';
    const [h, m] = time.split(':');
    return `${parseInt(h)}h${m === '00' ? '' : m}`;
  };

  if (loading) return <div className="opening-hours-container"><p>Chargement des horaires...</p></div>;

  return (
    <div className="opening-hours-container">
      <h3 className="hours-title">Nos Horaires</h3>
      <ul className="hours-list">
        {hoursToDisplay.map(item => (
          <li key={item.day || item.id} className={`hours-item ${item.day === currentDayId ? 'today' : ''}`}>
            <span className="day-name">{daysMap[item.day]}</span>
            <span className="hours-details">
              {item.is_closed ? (
                'Fermé'
              ) : (
                <>
                  {formatTime(item.open)} – {formatTime(item.break_start || item.close)}
                  {item.break_end && item.break_end !== item.close && (
                    <> <br /> {formatTime(item.break_end)} – {formatTime(item.close)}</>
                  )}
                </>
              )}
            </span>
          </li>
        ))}
      </ul>

      {/* Message Info / Vacances */}
      {salonInfos?.info_message && (
        <div className="hours-note info-message-box">
          <p>{salonInfos.info_message}</p>
        </div>
      )}

      {/* Liste des fermetures exceptionnelles */}
      {futureBlockedDates.length > 0 && (
        <div className="blocked-dates-alert">
          <h4>⚠️ Fermetures à venir :</h4>
          <ul>
            {futureBlockedDates.map(bd => (
              <li key={bd.id}>
                <strong>{new Date(bd.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' })}</strong> : {bd.reason}
              </li>
            ))}
          </ul>
        </div>
      )}

      {!salonInfos?.info_message && (
        <p className="hours-note">
          Les horaires peuvent varier les jours fériés.
        </p>
      )}
    </div>
  );
}

export default OpeningHours;